import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid py-4 pt-5 mt-5" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title mb-0" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4" }
const _hoisted_23 = { class: "d-flex align-items-center gap-2" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "pagination-mini" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled", "onClick"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "card-footer bg-light"
}
const _hoisted_30 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_33 = { class: "color-preview" }
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_36 = { class: "color-preview" }
const _hoisted_37 = { class: "text-muted" }

import { ref, computed, onMounted, watch, defineAsyncComponent } from "vue";
import { useCrud } from "@/composables/commen/useCrud";
import BaseModal from "@/components/commen/modal/BaseModal.vue";
import BaseForm from "@/components/commen/modal/BaseForm.vue"; 
import apiService from "@/services/apiService";
import CommonTable from "@/components/commen/table/CommonTable.vue";
import TableBreadCrumbs from "@/components/commen/table/TableBreadCrumbs.vue";
import { usePermissions } from "@/composables/usePermissions";
import CommonTable2 from "@/components/commen/table/CommonTable2.vue";


// Define IconUploader as async component
const API_RESOURCE = "/common/cardpriority";
const pageTitle = "Card Priorities";
const title = "Card Priorities List";

export default /*@__PURE__*/_defineComponent({
  __name: 'cardpriorityList',
  setup(__props) {

const { canCreate } = usePermissions();
const IconPicker = defineAsyncComponent({
  loader: () => import("@/components/commen/modal/IconUploader.vue"),
  loadingComponent: {
    template: `
      <div class="text-center py-3">
        <div class="spinner-border spinner-border-sm" role="status"></div>
        <span class="ms-2">Loading icon picker...</span>
      </div>
    `,
  },
  errorComponent: {
    template: `
      <div class="alert alert-warning">
        <small>Icon picker unavailable. Using manual selection.</small>
      </div>
    `,
  },
  delay: 200,
  timeout: 3000,
});

const crud = useCrud(API_RESOURCE);

// Tab state
const activeTab = ref<"default" | "byusers">("default");
const isLoading = ref(false);
const error = ref<string | null>(null);
const cardTypes = ref<any[]>([]);
const pagination = ref<any[]>([]) ;

// Computed properties
const currentTabTitle = computed(() =>
  activeTab.value === "default"
    ? "Default Card Priorities"
    : "By Users Card Priorities"
);

// pagination local UI state (mirrors backend, but we keep per_page from UI)
const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

const currentPage = ref(1);
// visiblePages computed (same advanced logic)
const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  if (!total || total <= 4) {
    return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  }

  const pages: (number | string)[] = [];
  pages.push(1);

  if (current > 4) pages.push("...");

  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);

  if (current < total - 3) pages.push("...");

  pages.push(total);
  return pages;
});
// Sync backend pagination into tablePagination, but DO NOT overwrite UI per_page except if UI didn't set it.
watch(
  () => pagination.value,
  (newVal) => {
    if (!newVal) return;

    tablePagination.value.current_page = newVal.current_page || 1;
    tablePagination.value.total_pages = newVal.total_pages || 1;
    tablePagination.value.total = newVal.total || 0;

    // keep UI rows per page unless backend changed
    tablePagination.value.per_page = tablePagination.value.per_page;
    tablePagination.value.has_prev = tablePagination.value.current_page > 1;
    tablePagination.value.has_next =
      tablePagination.value.current_page < tablePagination.value.total_pages;
  },
  { immediate: true, deep: true }
);

// --- Table ---
const tableConfig = computed(() => ({
  columns: [
    { name: "Title", field: "title", sortable: true },
    {
      name: "Color",
      field: "color",
      sortable: false,
      render: (value: string) => {
        if (!value) return '<span class="text-muted">No color</span>';
        return `
          <div class="d-flex align-items-center">
            <div class="color-swatch me-2" style="width: 20px; height: 20px; background-color: ${value}; border: 1px solid #ccc; border-radius: 3px;"></div>
            <span class="text-uppercase">${value}</span>
          </div>
        `;
      },
    },
  ],
  data: cardTypes.value,
  actions: activeTab.value === "default" ? [true] : [false],
  loading: isLoading.value,
}));

// --- Modals ---
const isCreateModalOpen = ref(false);
const isEditModalOpen = ref(false);
const isViewMode = ref(false);

// --- Form Data ---
const newItemData = ref({ title: "", color: "#007bff" });
const editingItemData = ref({ _id: "", title: "", color: "#007bff" });

// --- Form Fields (with color) ---
const createFormFields = [
  {
    key: "title",
    label: "Title",
    type: "text" as const,
    required: true,
    placeholder: "Enter title",
  },
  {
    key: "color",
    label: "Color",
    type: "color" as const,
    required: true,
    placeholder: "Select color",
  },
];
const editFormFields = computed(() => [
  {
    key: "title",
    label: "Title",
    type: "text" as const,
    required: true,
    placeholder: "Enter title",
    readonly: isViewMode.value,
  },
  {
    key: "color",
    label: "Color",
    type: "color" as const,
    required: true,
    placeholder: "Select color",
    readonly: isViewMode.value,
  },
]);

// --- Validation ---
const isCreateFormValid = computed(
  () => !newItemData.value.title.trim() || !newItemData.value.color
);
const isEditFormValid = computed(
  () => !editingItemData.value.title?.trim() || !editingItemData.value.color
);

// Tab methods
const setActiveTab = (tab: "default" | "byusers") => {
  activeTab.value = tab;
  fetchCardTypes();
};

const fetchCardTypes = async () => {
  isLoading.value = true;
  error.value = null;

  try {
    console.log(`Fetching ${activeTab.value} card priorities...`);
    const isDefault = activeTab.value === "default";
    const endpoint =
  `/common/cardpriority-filtered?default=${isDefault}` +
  `&page=${tablePagination.value.current_page}` +
  `&limit=${tablePagination.value.per_page}`;

    const response = await apiService.get(endpoint);
    console.log("Card Types API Response:", response);
    if(response.pagination){
      pagination.value = response.pagination;
    }

    if (Array.isArray(response)) {
      cardTypes.value = response;
      console.log(
        `Loaded ${cardTypes.value.length} ${activeTab.value} card types`
      );
    } else if (response && response.data && Array.isArray(response.data)) {
      cardTypes.value = response.data;
      console.log(
        `Loaded ${cardTypes.value.length} ${activeTab.value} card types`
      );
    } else {
      console.error("Unexpected response structure:", response);
      throw new Error("Invalid response format");
    }
  } catch (err: any) {
    console.error("Error fetching card types:", err);
    error.value =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to load card types";
  } finally {
    isLoading.value = false;
  }
};

const changeRows = async () => {
  tablePagination.value.current_page = 1;  
  await fetchCardTypes();
};

const goToPage = async (page: number) => {
  if (page < 1 || page > tablePagination.value.total_pages) return;

  tablePagination.value.current_page = page;

  await fetchCardTypes();
};



const openCreateModal = () => {
  isCreateModalOpen.value = true;
};

// --- Handlers ---
const handleEdit = (row: any) => {
  isViewMode.value = false;
  editingItemData.value = { ...row };
  isEditModalOpen.value = true;
};
const handleView = (row: any) => {
  isViewMode.value = true;
  editingItemData.value = { ...row };
  isEditModalOpen.value = true;
};
const handleDelete = async (id: string) => {
  if (confirm("Are you sure?")) {
    await crud.deleteItem(id);
    await fetchCardTypes(); // Refresh the current tab data
  }
};

const handleSaveCreate = async () => {
  if (isCreateFormValid.value) return;
  const payload = { ...newItemData.value };
  const result = await crud.createItem(payload);
  if (result) {
    closeCreateModal();
    await fetchCardTypes(); // Refresh the current tab data
  }
};

const handleSaveEdit = async () => {
  const id = editingItemData.value._id;
  if (!id) return;
  const { _id, ...updatePayload } = editingItemData.value;
  const result = await crud.updateItem(id, updatePayload);
  if (result) {
    closeEditModal();
    await fetchCardTypes(); // Refresh the current tab data
  }
};

const closeCreateModal = () => {
  isCreateModalOpen.value = false;
  newItemData.value = { title: "", color: "#007bff" };
};
const closeEditModal = () => {
  isEditModalOpen.value = false;
  isViewMode.value = false;
  editingItemData.value = { _id: "", title: "", color: "#007bff" };
};

onMounted(async () => {
  await fetchCardTypes();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TableBreadCrumbs, { title: "Card Priorities" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'default' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('default'))),
              type: "button"
            }, " Default ", 2)
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'byusers' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('byusers'))),
              type: "button"
            }, " By Users ", 2)
          ])
        ]),
        (activeTab.value === 'default')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: openCreateModal,
              disabled: !_unref(canCreate)('data')
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fa fa-plus me-2" }, null, -1),
              _createTextVNode(" Create New Priority ", -1)
            ]))], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(currentTabTitle.value), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ], -1)),
                _createElementVNode("p", _hoisted_12, " Loading " + _toDisplayString(activeTab.value === "default" ? "Default" : "By Users") + " card priorities... ", 1)
              ]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Error:", -1)),
                      _createTextVNode(" " + _toDisplayString(error.value), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger",
                      onClick: fetchCardTypes
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                      _createTextVNode(" Retry ", -1)
                    ]))])
                  ])
                ]))
              : (cardTypes.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(CommonTable2, {
                      tableObj: tableConfig.value,
                      title: '',
                      onEdit: handleEdit,
                      onDelete: handleDelete,
                      onView: handleView,
                      permissionKey: "data"
                    }, null, 8, ["tableObj"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-3" }, [
                      _createElementVNode("i", { class: "fa fa-credit-card fa-3x text-muted" })
                    ], -1)),
                    _createElementVNode("h5", _hoisted_18, " No " + _toDisplayString(activeTab.value === "default" ? "Default" : "By Users") + " Card Priorities Found ", 1),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(activeTab.value === "default"
                ? "No default card priorities are available."
                : "No By Users card priorities are available."), 1),
                    _createElementVNode("div", _hoisted_20, [
                      (activeTab.value === 'default')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary me-2",
                            onClick: openCreateModal,
                            disabled: !_unref(canCreate)('data')
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                            _createTextVNode(" Create Card Priority ", -1)
                          ]))], 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        onClick: fetchCardTypes
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                        _createTextVNode(" Refresh ", -1)
                      ]))])
                    ])
                  ]))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm rows-select",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tablePagination.value.per_page) = $event)),
              onChange: changeRows
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                return _createElementVNode("option", {
                  key: n,
                  value: n
                }, _toDisplayString(n), 9, _hoisted_24)
              }), 64))
            ], 544), [
              [_vModelSelect, tablePagination.value.per_page]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              class: "page-btn prev_btn",
              disabled: !tablePagination.value.has_prev,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(tablePagination.value.current_page - 1)))
            }, " « ", 8, _hoisted_26),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass(["page-btn", {
              'page-active': p === tablePagination.value.current_page,
              'disabled-dots': p === '...',
            }]),
                disabled: p === '...',
                onClick: ($event: any) => (p !== '...' && goToPage(p))
              }, _toDisplayString(p), 11, _hoisted_27))
            }), 128)),
            _createElementVNode("button", {
              class: "page-btn next_btn",
              disabled: !tablePagination.value.has_next,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage(tablePagination.value.current_page + 1)))
            }, " » ", 8, _hoisted_28)
          ])
        ]),
        (cardTypes.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("small", _hoisted_31, " Showing " + _toDisplayString(cardTypes.value.length) + " " + _toDisplayString(activeTab.value === "default" ? "default" : "By Users") + " card priority" + _toDisplayString(cardTypes.value.length !== 1 ? "s" : ""), 1),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-secondary",
                  onClick: fetchCardTypes
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                  _createTextVNode(" Refresh ", -1)
                ]))])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(BaseModal, {
      id: "createNew",
      title: `Create ${pageTitle}`,
      visible: isCreateModalOpen.value,
      onClose: closeCreateModal,
      onSave: handleSaveCreate,
      "save-button-disabled": isCreateFormValid.value
    }, {
      body: _withCtx(() => [
        _createVNode(BaseForm, {
          fields: createFormFields,
          modelValue: newItemData.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newItemData).value = $event)),
          ref: "createFormRef"
        }, null, 8, ["modelValue"]),
        (newItemData.value.color)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label" }, "Color Preview", -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  class: "color-preview-swatch",
                  style: _normalizeStyle({ backgroundColor: newItemData.value.color })
                }, null, 4),
                _createElementVNode("small", _hoisted_34, _toDisplayString(newItemData.value.color.toUpperCase()), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "visible", "save-button-disabled"]),
    _createVNode(BaseModal, {
      id: "editModal",
      title: `${isViewMode.value ? 'View' : 'Edit'} ${pageTitle}`,
      visible: isEditModalOpen.value,
      onClose: closeEditModal,
      onSave: handleSaveEdit,
      "show-save-button": !isViewMode.value,
      "save-button-disabled": isEditFormValid.value
    }, {
      body: _withCtx(() => [
        _createVNode(BaseForm, {
          fields: editFormFields.value,
          modelValue: editingItemData.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editingItemData).value = $event)),
          ref: "editFormRef"
        }, null, 8, ["fields", "modelValue"]),
        (editingItemData.value.color)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, "Color Preview", -1)),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", {
                  class: "color-preview-swatch",
                  style: _normalizeStyle({ backgroundColor: editingItemData.value.color })
                }, null, 4),
                _createElementVNode("small", _hoisted_37, _toDisplayString(editingItemData.value.color.toUpperCase()), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "visible", "show-save-button", "save-button-disabled"])
  ], 64))
}
}

})